import type { CSSProperties } from 'react';
import type { BoxLayout, ComponentMetaInput } from '../../ui';

const PAGE = 'marketplace';
export const MARKETPLACE_COMPONENTS: ComponentMetaInput[] = [
  { id: 'marketplace.root', page: PAGE, role: 'container', label: '模型广场页', layout: { x: 0, y: 24, width: 390, height: 744 }, zIndex: 1, notes: '安卓用 Fragment 根容器；内容可滚动' },
  { id: 'marketplace.header', page: PAGE, role: 'container', label: '模型广场页头部', layout: { x: 0, y: 24, width: 390, height: 56 }, zIndex: 2, notes: '安卓用 MaterialToolbar' },
  { id: 'marketplace.title', page: PAGE, role: 'text', label: '模型广场标题', layout: { x: 16, y: 36, width: 300, height: 32 }, zIndex: 3, notes: '安卓用 Toolbar 标题 TextView' },
  { id: 'marketplace.list', page: PAGE, role: 'list', label: '官方模型列表', layout: { x: 16, y: 96, width: 358, height: 620 }, zIndex: 2, props: ['items', 'loading'], notes: '安卓用 RecyclerView；按模型卡片复用布局' },
  { id: 'marketplace.notice', page: PAGE, role: 'text', label: '模型广场状态提示', layout: { x: 16, y: 96, width: 358, height: 72 }, zIndex: 3, notes: '安卓用 TextView；显示登录、网络或空状态' },
];

export function marketplaceMeta(id: string): ComponentMetaInput {
  const found = MARKETPLACE_COMPONENTS.find((meta) => meta.id === id);
  if (found === undefined) throw new Error(`[marketplace] 未登记的部件：${id}`);
  return found;
}

export function marketplaceCardMeta(index: number): ComponentMetaInput {
  return { id: `marketplace.model.${index}`, page: PAGE, role: 'container', label: '栀歆模型卡片', layout: { x: 16, y: 104 + index * 176, width: 358, height: 160 }, zIndex: 3, props: ['name', 'price', 'capabilities'], notes: '安卓用 CardView 和 wrap_content；卡片随内容撑开，文字模型展示上下文和 Token 价格，图片模型展示 1k / 2k / 4k 每张价格' };
}

export function contentStyle(layout: BoxLayout): CSSProperties {
  return { position: 'absolute', left: layout.x, top: layout.y - 24, width: layout.width, height: layout.height };
}
